import React, { createContext, useContext, useState, ReactNode } from "react";
import { Branch } from "../types/branch";

interface BranchContextType {
  branches: Branch[];
  selectedBranch: Branch | null;
  setBranches: (branches: Branch[]) => void;
  setSelectedBranch: (branch: Branch | null) => void;
}

export const BranchContext = createContext<BranchContextType | undefined>(
  undefined
);

export const BranchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null);

  return (
    <BranchContext.Provider
      value={{ branches, selectedBranch, setBranches, setSelectedBranch }}
    >
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = (): BranchContextType => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error("useBranch must be used within a BranchProvider");
  }
  return context;
};
